import { createAction, props } from '@ngrx/store';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export const nextButtonClicked = createAction(
  '[DashboardNavigation] Next Button Clicked'
);

export const backButtonClicked = createAction(
  '[DashboardNavigation] Back Button Clicked'
);

export const resetButtons = createAction(
  '[DashboardNavigation] Reset Buttons'
);

export const setupNavigation = createAction(
  '[DashboardNavigation] Set Navigation',
  props<{ navCommands: KeyValueDict<string> }>()
);

export const temporaryChange = createAction(
  '[DashboardNavigation] Toggle Temporary Change'
);

export type DashboardNavigationActionsUnion = ReturnType<typeof nextButtonClicked | typeof backButtonClicked | typeof resetButtons | typeof setupNavigation>;


